import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import Page from '../../components/Page';
import * as dateFormat from 'dateformat';
import Section from '../../components/Section';
import { Text, TextArea } from '../../components/forms';
import { Order, NewFulfillment } from '../../order';
import { ActionBar, ActionBarStyle } from '../../components/ActionBar';
import { ButtonStyle } from '../../components/Button';
import { useRequestAsync, getHeaders } from '../../api/client';
import { ProfileContext } from '../../profile';
import Loader from '../../components/Loader';
import Flash, { ErrorFlash } from '../../components/Flash';

interface Props extends RouteComponentProps<any> {}

const DATE_FORMAT = 'd mmmm, yyyy - HH:MM:s';

const getStateEntity = (props: RouteComponentProps<any>): Order => {
  return props.location.state ? props.location.state.order : null;
};

export default function CancelOrderShipment(props: Props) {
  const context = React.useContext(ProfileContext);
  const order: Order = getStateEntity(props);
  const [notes, setNotes] = React.useState(null);

  const [state, submit] = useRequestAsync((data: NewFulfillment) => ({
    url: `/store/orders/${order.id}/shipments/${order.shipments[0].id}/cancel`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page
      title="Order Details"
      subtitle={`#${order.order_number} — Placed on ${dateFormat(
        order.created_at,
        DATE_FORMAT,
      )}`}
    >
      {state.error && <ErrorFlash error={state.error} />}
      {state.complete && !state.error && (
        <Flash text="Order has been updated" />
      )}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={`/orders/${order.id}`}
          className="f5 link br-pill bg-near-white hover-bg-black-10 ph4 pv3 mh2 b black"
        >
          ← Back to Order
        </Link>
      </div>
      <form onSubmit={() => submit({ notes })}>
        <Section title="Cancel order">
          <div className="flex">
            <div className="flex-auto w-100 w-50-ns pr3">
              <TextArea
                label="Notes"
                field={['notes']}
                id="notes"
                defaultValue={notes}
                placeholder="Any information that the customer might need"
                onValueChange={(_: string, newValue: string) =>
                  setNotes(newValue)
                }
              />
            </div>
          </div>
        </Section>
        <ActionBar
          className={ActionBarStyle.alignCenter}
          actions={[
            {
              className: ButtonStyle.Confirm,
              label: 'Mark as cancelled',
              handler: () => submit({ notes }),
            },
          ]}
        />
      </form>
    </Page>
  );
}
